// extracted by mini-css-extract-plugin
export default {"wrapping-ellipse-container":"Ellipse_wrapping-ellipse-container__B42BX"};